export default "__VITE_ASSET__BX0xkGOJ__"